enum SelectAllState {
  NONE = "none",
  PARTIAL = "partial",
  ALL = "all",
  INITIAL = "initial",
}

export default SelectAllState;
